// ProfileCard — compact card for trader suggestions / search results.
import React from "react";
import { Link } from "react-router-dom";
import { UserAvatar } from "./UserAvatar";
import { BadgeDisplay } from "./BadgeDisplay";
import { FollowButton } from "./FollowButton";
import { useLanguage } from "../../i18n/LanguageContext";
import { tShadow } from "../../i18n/shadow-social";

export const ProfileCard = ({
  profile,
  showFollowButton = true,
  initialFollowing = false,
}) => {
  const { lang } = useLanguage();
  if (!profile?.user) return null;
  const u = profile.user;
  const stats = profile.stats || {};
  const badges = profile.badges || [];
  const followers = profile.followers_count ?? 0;
  const handle = u.username ? `@${u.username}` : u.operator_codename || "";

  return (
    <article
      data-testid={`profile-card-${u.username || u.id}`}
      className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-4 backdrop-blur-xl transition-colors hover:border-amber-400/40"
    >
      <Link to={u.username ? `/shadow/perfil/${u.username}` : "#"}>
        <UserAvatar user={u} size="lg" />
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <Link
            to={u.username ? `/shadow/perfil/${u.username}` : "#"}
            className="truncate text-sm font-bold text-white hover:underline"
          >
            {u.name}
          </Link>
          {handle && (
            <span className="text-xs text-white/45 truncate">{handle}</span>
          )}
          {badges.length > 0 && <BadgeDisplay badges={badges} max={3} size="sm" />}
        </div>
        {u.bio && (
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-white/60">
            {u.bio}
          </p>
        )}
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] uppercase tracking-[0.15em] text-white/45">
          <span>
            <span className="text-white/85 font-bold">{stats.total_analyses || 0}</span>{" "}
            {tShadow("analisis", lang)}
          </span>
          {stats.win_rate > 0 && (
            <span>
              <span className="text-white/85 font-bold">
                {Math.round(stats.win_rate)}%
              </span>{" "}
              {tShadow("winRate", lang)}
            </span>
          )}
          <span>
            <span className="text-white/85 font-bold">{followers}</span>{" "}
            {tShadow("seguidores", lang)}
          </span>
        </div>
      </div>
      {showFollowButton && (
        <FollowButton
          targetUserId={u.id}
          initialFollowing={initialFollowing}
          size="sm"
        />
      )}
    </article>
  );
};

export default ProfileCard;
